import { PageSize } from '@/constant';
import {
	GetWorkerAssignmentListParams,
	IWorkerAssignmentFranchiseListItem,
	IWorkerAssignmentListItem,
	TPayloadUpdateSuccess,
} from '@/services';
import { mergeListItemUpdated } from '@/utils';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import { formatWorkerAssignmentFranchiseList } from './worker-assignment-franchise.helper';
import {
	IPayloadDeleteWorkerAssignmentFranchiseRequest,
	IPayloadGetWorkerAssignmentFranchiseExcelListRequest,
	IPayloadGetWorkerAssignmentFranchiseListRequest,
	IPayloadGetWorkerAssignmentFranchiseListSuccess,
	IWorkerAssignmentFranchiseListStore,
} from './worker-assignment-franchise.type';

const InitParams: GetWorkerAssignmentListParams = {
	page: 1,
	pageSize: PageSize.S,
	searchTypes: [],
};

const initialState = {
	fetching: false,
	workerAssignmentFranchiseList: [] as IWorkerAssignmentFranchiseListStore[],
	total: 0,
	params: InitParams,

	excelListFetching: false,
};

const workerAssignmentFranchiseSlice = createSlice({
	initialState,
	name: 'workerAssignmentFranchise',
	reducers: {
		/**---- GET WORKER ASSIGNMENT FRANCHISE LIST START ---- */
		getWorkerAssignmentFranchiseListRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerAssignmentFranchiseListRequest>
		) => {
			return {
				...state,
				fetching: true,
				params: action?.payload,
			};
		},
		getWorkerAssignmentFranchiseListSuccess: (
			state,
			action: PayloadAction<IPayloadGetWorkerAssignmentFranchiseListSuccess>
		) => {
			const { content, total } = action.payload;
			state.fetching = false;
			state.workerAssignmentFranchiseList = content;
			state.total = total;
		},
		getWorkerAssignmentFranchiseListFailure: (state) => {
			state.fetching = false;
			state.workerAssignmentFranchiseList = [];
			state.total = 0;
		},

		getWorkerAssignmentFranchiseExcelListRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerAssignmentFranchiseExcelListRequest>
		) => {
			state.excelListFetching = true;
		},
		getWorkerAssignmentFranchiseExcelListSuccess: (state) => {
			state.excelListFetching = false;
		},
		getWorkerAssignmentFranchiseExcelListFailure: (state) => {
			state.excelListFetching = false;
		},
		/**---- GET WORKER ASSIGNMENT FRANCHISE LIST END ---- */

		/**---- UPDATE WORKER ASSIGNMENT FRANCHISE START ---- */
		updateWorkerAssignmentFranchiseListSuccess: (
			state,
			action: PayloadAction<
				TPayloadUpdateSuccess<IWorkerAssignmentFranchiseListItem>
			>
		) => {
			const { data } = action.payload;
			const workerAssignmentFranchiseList = [
				...state.workerAssignmentFranchiseList,
			];
			state.workerAssignmentFranchiseList = formatWorkerAssignmentFranchiseList(
				mergeListItemUpdated<
					IWorkerAssignmentFranchiseListStore,
					IWorkerAssignmentListItem
				>(workerAssignmentFranchiseList, data)
			);
		},
		/**---- UPDATE WORKER ASSIGNMENT FRANCHISE END ---- */

		/**---- DELETE WORKER ASSIGNMENT FRANCHISE START ---- */
		deleteWorkerAssignmentFranchiseRequest: (
			state,
			action: PayloadAction<IPayloadDeleteWorkerAssignmentFranchiseRequest>
		) => {
			state.fetching = true;
		},
		deleteWorkerAssignmentFranchiseSuccess: (state) => {
			state.fetching = false;
		},
		deleteWorkerAssignmentFranchiseFailure: (state) => {
			state.fetching = false;
		},
		/**---- DELETE WORKER ASSIGNMENT FRANCHISE END ---- */
	},
});

export const WorkerAssignmentFranchiseSelectors = {
	selectFetching: (state: RootState) =>
		state.workerAssignmentFranchise.fetching,
	selectParams: (state: RootState) => state.workerAssignmentFranchise.params,
	selectList: (state: RootState) =>
		state.workerAssignmentFranchise.workerAssignmentFranchiseList,
	selectTotal: (state: RootState) => state.workerAssignmentFranchise.total,
};

export const WorkerAssignmentFranchiseActions =
	workerAssignmentFranchiseSlice.actions;
export const WorkerAssignmentFranchiseReducer =
	workerAssignmentFranchiseSlice.reducer;
